import { generateClient } from 'aws-amplify/api';
import { createSubmission } from '../graphql/mutations';

const client = generateClient();

export const saveSubmission = async ({
  participantId,
  formType,
  demographics = {},
  raw = {},
  metrics = {},
  year,
  month,
}) => {
  try {
    const input = {
      participantId,
      formType,
      demographics: JSON.stringify(demographics ?? {}),
      raw: JSON.stringify(raw ?? {}),
      metrics: JSON.stringify(metrics ?? {}),
      year: Number(year) || null,
      month: Number(month) || null,
    };

    console.log("🧾 Saving Submission with input:", input);

    const result = await client.graphql({
      query: createSubmission,
      variables: { input },
    });

    console.log('✅ Submission saved:', result.data.createSubmission);
    return result.data.createSubmission;

  } catch (error) {
    console.error('❌ GraphQL Submission Error:', JSON.stringify(error, null, 2));
    throw error;
  }
};
